import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-88" data-mp="ei1unjxvvyww">
      <div className="bg-grid-lines absolute inset-0 opacity-60" aria-hidden="true" data-id="element-89" data-mp="9lbgx39jxfen" />

      <div className="relative mx-auto max-w-5xl px-5 pb-8 pt-4 text-center sm:pt-14" data-id="element-90" data-mp="4n1lqsntuet1">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-plata" style={{
        color: "#7FD4FF"
      }} data-id="element-91" data-mp="129qs1epkbdkp">
          🏆 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-white sm:text-[30px]" data-id="element-92" data-mp="nb6llp1d5fmk">
          APRENDISTE A CORRER, TE HICISTE MAS FUERTE...
 AHORA SUBE DE NIVEL Y DOMINA TU MENTE
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-neon-azul pb-1 pt-1 font-display text-[26px] font-bold uppercase tracking-tight sm:text-5xl" data-id="element-93" data-mp="3814cjrqd82pe">
          NEURO-RUNNING PACK
        </motion.h1>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-2 w-full max-w-3xl" data-id="element-94" data-mp="3e7l5nw9dmagj">
          <div className="absolute inset-x-8 bottom-4 -z-10 h-40 rounded-full bg-azul/25 blur-3xl" aria-hidden="true" data-id="element-95" data-mp="2qlep2llvzmep" />
          <img src="https://cdn.magicpatterns.com/uploads/k18ZLSBLDc9AYEk5chdt3Z/ChatGPT_Image_14_ago_2026,_14_48_59.png" alt="Neuro-Running Pack — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto aspect-[3/2] w-full rounded-2xl object-contain" data-id="element-96" data-mp="2vgu0z80c388h" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-xs font-semibold uppercase tracking-[0.18em] text-white/50" style={{
        color: "#FFFFFF"
      }} data-id="element-97" data-mp="s3cmudv0pps5">
          EL SISTEMA N°1 DE PSICOLOGÍA DEPORTIVA PARA CORREDORES QUE QUIEREN DOMINAR SU MENTE.
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-98" data-mp="1azkqxecanulv">
          <CTAButton href="#value" data-id="element-99" data-mp="1622kpvpnvthk">⚡ Quiero el Neuro-Pack ahora</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-100" data-mp="15zzwnh82kafh">
            Todo lo que necesitás para atravesar el muro, silenciar el autosabotaje, controlar los
            nervios pre-carrera y entrar en la zona. Sin improvisar. Sin abandonar. Sin depender de
            la motivación del día.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3,
          delay: 0.3,
          ease: 'easeOut'
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plata sm:text-xl" data-id="element-101" data-mp="3hr3sjxze2f6v">
            Neurobiología · Umbral del Dolor · Flow · Ansiedad · Visualización · Identidad
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-102" data-mp="2b0zduu7op7os">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-azul/25 bg-azul/10 px-3.5 py-1.5 text-xs font-semibold text-white/85" data-id="element-103" data-mp="2g1wvn5os7zpr">
                <Icon className="h-3.5 w-3.5 text-azul-soft" data-id="element-104" data-mp="2p1a4px8zum9y" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-white/50" data-id="element-105" data-mp="2tx7ko2gchqm7">
            12 Tomos · 5 Bonos · +100 páginas — Todo resuelto.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-106" data-mp="zmc68jihbhbi">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-107" data-mp="3vgvvsob6z945">
              <Icon className="h-4 w-4 text-plata" data-id="element-108" data-mp="e88vbyqgya2w" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-naranja/50 bg-naranja/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-naranja-soft" data-id="element-109" data-mp="9bs4uxvsrjmn">
          🔥 Oferta de lanzamiento cierra pronto · No vuelve a este precio
        </motion.div>
      </div>
    </header>;
}